module.exports = __webpack_public_path__ + "static/img/robot-logo.2bd59431.png";